import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import { toast } from "react-toastify";

const calculateTotal = (data, getFieldValue) => {
    return data.reduce((total, item) => {
        return total + Number(getFieldValue(item));
    }, 0);
};

const formatCurrencyIndian = (amount) => {
    if (amount === null || amount === undefined) return "-";
    const hasDecimals = amount % 1 !== 0;

    return new Intl.NumberFormat("en-IN", {
        maximumSignificantDigits: 21,
        minimumFractionDigits: hasDecimals ? 2 : 0,
        maximumFractionDigits: hasDecimals ? 2 : 0,
    }).format(amount);
};

const CSSforMulti = {

    control: (provided) => ({
        ...provided,
        width: '33.5vw',
        minHeight: '50px',
        borderRadius: '10px',
        border: '1px solid #e3e3e3',
        margin: '10px 0px 20px 0px',
        color: '#4a4a4a',
        backgroundColor: '#f7f8fa',
        padding: '0px 10px',
    }),
    placeholder: (provided) => ({
        ...provided,
        color: '#4a4a4a',
    }),
    menu: (provided) => ({
        ...provided,
        width: '33.5vw',
        borderRadius: '10px',
        marginTop: '0',
    }),
    singleValue: (provided) => ({
        ...provided,
        color: '#4a4a4a',
    }),
    input: (provided) => ({
        ...provided,
        color: '#4a4a4a',
    }),

    option: (provided, state) => ({
        ...provided,
        backgroundColor: state.isSelected
            ? "#cfe2ff"
            : state.isFocused
                ? "#cfe2ff"
                : "white",

        color: "#4a4a4a",
        padding: "8px 12px",
        ":active": {
            backgroundColor: "#cfe2ff",
        }
    }),



}
const CSSforMulti100Width = {

    control: (provided) => ({
        ...provided,
        width: '77vw',
        minHeight: '50px',
        borderRadius: '10px',
        border: '1px solid #e3e3e3',
        margin: '10px 0px 20px 0px',
        color: '#4a4a4a',
        backgroundColor: '#f7f8fa',
        padding: '0px 10px',
    }),
    placeholder: (provided) => ({
        ...provided,
        color: '#4a4a4a',
    }),
    menu: (provided) => ({
        ...provided,
        width: '77vw',
        borderRadius: '10px',
        marginTop: '0',
    }),
    singleValue: (provided) => ({
        ...provided,
        color: '#4a4a4a',
    }),
    input: (provided) => ({
        ...provided,
        color: '#4a4a4a',
    }),

    option: (provided, state) => ({
        ...provided,
        backgroundColor: state.isSelected
            ? "#cfe2ff"
            : state.isFocused
                ? "#cfe2ff"
                : "white",

        color: "#4a4a4a",
        padding: "8px 12px",
        ":active": {
            backgroundColor: "#cfe2ff",
        }
    }),



}
const CSSForSelect = {
    control: (provided) => ({
        ...provided,
        width: '34vw',
        minWidth: '34vw',
        height: '50px',
        borderRadius: '10px',
        border: '1px solid #e3e3e3',
        margin: '10px 0px 20px 0px',
        color: '#4a4a4a',
        backgroundColor: '#f7f8fa',
        padding: '0px 10px',
        textTransform: "capitalize",
    }),
    placeholder: (provided) => ({
        ...provided,
        color: '#4a4a4a',
        textTransform: "capitalize",
    }),
    menu: (provided) => ({
        ...provided,
        width: '34vw',
        minWidth: '34vw',
        borderRadius: '10px',
        marginTop: '0',
        zIndex: 5,
    }),
    menuList: (provided) => ({
        ...provided,
        width: '34vw',
        minWidth: '34vw',
        padding: 0,
    }),
    menuPortal: (provided) => ({
        ...provided,
        zIndex: 9999,
    }),
    singleValue: (provided) => ({
        ...provided,
        color: '#4a4a4a',
        textTransform: "capitalize",
    }),
    input: (provided) => ({
        ...provided,
        color: '#4a4a4a',
        textTransform: "capitalize",
    }),
    option: (provided, state) => ({
        ...provided,
        textTransform: "capitalize",
        backgroundColor: state.isFocused ? "#e6f0ff" : "#fff",
        color: '#4a4a4a',
    }),
};
const CSSForSelect15VW = {
    control: (provided) => ({
        ...provided,
        width: '15vw',
        minWidth: '15vw',
        height: '50px',
        borderRadius: '10px',
        border: '1px solid #e3e3e3',
        margin: '10px 0px 20px 0px',
        color: '#4a4a4a',
        backgroundColor: '#f7f8fa',
        padding: '0px 10px',
        textTransform: "capitalize",
    }),
    placeholder: (provided) => ({
        ...provided,
        color: '#4a4a4a',
        textTransform: "capitalize",
    }),
    menu: (provided) => ({
        ...provided,
        width: '15vw',
        minWidth: '15vw',
        borderRadius: '10px',
        marginTop: '0',
        zIndex: 5,
    }),
    menuList: (provided) => ({
        ...provided,
        width: '15vw',
        minWidth: '15vw',
        padding: 0,
    }),
    menuPortal: (provided) => ({
        ...provided,
        zIndex: 9999,
    }),
    singleValue: (provided) => ({
        ...provided,
        color: '#4a4a4a',
        textTransform: "capitalize",
    }),
    input: (provided) => ({
        ...provided,
        color: '#4a4a4a',
        textTransform: "capitalize",
    }),
    option: (provided, state) => ({
        ...provided,
        textTransform: "capitalize",
        backgroundColor: state.isFocused ? "#e6f0ff" : "#fff",
        color: '#4a4a4a',
    }),
};

const truncateText = (text, wordLimit = 10) => {
    if (!text) return "-";
    const words = text.split(' ');
    if (words.length <= wordLimit) return text;
    return words.slice(0, wordLimit).join(' ') + '...';
};



// WorkStat Modal Component - Shows only NAME field
// const WorkStatModal = ({ isOpen, onClose, data,usedFor }) => {
//     const [hovered, setHovered] = useState(false);

//     if (!isOpen || !data) return null;
//     let dataval;

//     if(usedFor==="workstat"){
//         dataval=data.name
//     }

//     else if(usedFor==="project_name"){
//         dataval=data.project_name

//     }


//     return (
//         <div
//             style={{
//                 position: "fixed",
//                 top: 0,
//                 left: 0,
//                 right: 0,
//                 bottom: 0,
//                 height: "100vh",
//                 backgroundColor: "rgba(0, 0, 0, 0.5)",
//                 backdropFilter: "blur(8px)",
//                 display: "flex",
//                 alignItems: "center",
//                 justifyContent: "center",
//                 zIndex: 9999,
//                 animation: "fadeIn 0.3s ease"
//             }}
//             onClick={onClose}
//         >
//             <style>
//                 {`
//                     @keyframes fadeIn {
//                         from { opacity: 0; }
//                         to { opacity: 1; }
//                     }
//                     @keyframes slideUp {
//                         from { transform: translateY(30px); opacity: 0; }
//                         to { transform: translateY(0); opacity: 1; }
//                     }
//                 `}
//             </style>
//             <div
//                 style={{
//                     background: "white",
//                     borderRadius: "32px",
//                     maxWidth: "600px",
//                     width: "90%",
//                     position: "relative",
//                     boxShadow: "0 25px 50px -12px rgba(0, 0, 0, 0.25)",
//                     animation: "slideUp 0.4s cubic-bezier(0.16, 1, 0.3, 1)",
//                     border: "1px solid rgba(255, 255, 255, 0.5)",
//                     overflow: "hidden"
//                 }}
//                 onClick={(e) => e.stopPropagation()}
//             >
//                 {/* Modal Header - Same gradient as remarks modal */}
//                 <div style={{
//                     background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
//                     padding: "24px 32px",
//                     borderTopLeftRadius: "32px",
//                     borderTopRightRadius: "32px",
//                     display: "flex",
//                     alignItems: "center",
//                     justifyContent: "space-between"
//                 }}>
//                     <div style={{ display: "flex", alignItems: "center", gap: "16px" }}>
//                         <div style={{
//                             background: "rgba(255, 255, 255, 0.2)",
//                             width: "48px",
//                             height: "48px",
//                             borderRadius: "16px",
//                             display: "flex",
//                             alignItems: "center",
//                             justifyContent: "center",
//                             backdropFilter: "blur(4px)"
//                         }}>
//                             <span style={{ fontSize: "24px" }}>📋</span>
//                         </div>
//                         <div>
//                             <h2 style={{
//                                 margin: 0,
//                                 color: "white",
//                                 fontSize: "22px",
//                                 fontWeight: "700",
//                                 letterSpacing: "-0.5px"
//                             }}>
//                                 Work Stage Name
//                             </h2>
//                             <p style={{
//                                 margin: "4px 0 0 0",
//                                 color: "rgba(255, 255, 255, 0.9)",
//                                 fontSize: "14px"
//                             }}>
//                                 Complete name details
//                             </p>
//                         </div>
//                     </div>
//                     <button
//                         onClick={onClose}
//                         style={{
//                             background: "rgba(255, 255, 255, 0.2)",
//                             border: "none",
//                             width: "36px",
//                             height: "36px",
//                             borderRadius: "12px",
//                             display: "flex",
//                             alignItems: "center",
//                             justifyContent: "center",
//                             color: "white",
//                             fontSize: "24px",
//                             cursor: "pointer",
//                             backdropFilter: "blur(4px)",
//                             transition: "all 0.2s ease"
//                         }}
//                         onMouseEnter={(e) => {
//                             e.target.style.background = "rgba(255, 255, 255, 0.3)";
//                             e.target.style.transform = "scale(1.05)";
//                         }}
//                         onMouseLeave={(e) => {
//                             e.target.style.background = "rgba(255, 255, 255, 0.2)";
//                             e.target.style.transform = "scale(1)";
//                         }}
//                     >
//                         ×
//                     </button>
//                 </div>

//                 {/* Modal Content - Only Name Field */}
//                 <div 
//                     style={{
//                         padding: "32px",
//                         background: "linear-gradient(145deg, #ffffff 0%, #fafcff 100%)"
//                     }}
//                 >
//                     <div
//                         onMouseEnter={() => setHovered(true)}
//                         onMouseLeave={() => setHovered(false)}
//                         style={{
//                             background: hovered ? "#f8faff" : "white",
//                             borderRadius: "20px",
//                             padding: "28px",
//                             transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
//                             boxShadow: hovered
//                                 ? "0 8px 20px rgba(79, 114, 202, 0.12), 0 2px 6px rgba(79, 114, 202, 0.05)"
//                                 : "0 2px 8px rgba(0, 0, 0, 0.02)",
//                             transform: hovered ? "scale(1.01)" : "scale(1)",
//                             border: "1px solid rgba(255, 255, 255, 0.7)"
//                         }}
//                     >
//                         <div style={{
//                             display: "flex",
//                             alignItems: "flex-start",
//                             gap: "20px"
//                         }}>
//                             <div style={{
//                                 width: "48px",
//                                 height: "48px",
//                                 background: hovered
//                                     ? "linear-gradient(135deg, #667eea 0%, #764ba2 100%)"
//                                     : "#f3f4f6",
//                                 borderRadius: "16px",
//                                 display: "flex",
//                                 alignItems: "center",
//                                 justifyContent: "center",
//                                 color: hovered ? "white" : "#4b5563",
//                                 fontSize: "20px",
//                                 fontWeight: "600",
//                                 transition: "all 0.3s ease"
//                             }}>
//                                 📝
//                             </div>
//                             <div style={{ flex: 1 }}>
//                                 <div style={{
//                                     fontSize: "14px",
//                                     fontWeight: "600",
//                                     color: "#667eea",
//                                     textTransform: "uppercase",
//                                     letterSpacing: "0.5px",
//                                     marginBottom: "8px"
//                                 }}>
//                                     WORK STAGE NAME
//                                 </div>
//                                 <div style={{
//                                     fontSize: "18px",
//                                     color: hovered ? "#1e293b" : "#334155",
//                                     fontWeight: hovered ? "600" : "500",
//                                     lineHeight: "1.8",
//                                     wordBreak: "break-word",
//                                     whiteSpace: "pre-wrap",
//                                     background: hovered ? "rgba(102, 126, 234, 0.02)" : "transparent",
//                                     padding: "12px",
//                                     borderRadius: "12px",
//                                     transition: "all 0.2s ease"
//                                 }}>
//                                     {dataval || "-"}
//                                 </div>
//                                 {dataval && dataval.length > 200 && (
//                                     <div style={{
//                                         marginTop: "12px",
//                                         display: "flex",
//                                         alignItems: "center",
//                                         gap: "8px",
//                                         padding: "8px 12px",
//                                         background: "#e8f0fe",
//                                         borderRadius: "30px",
//                                         width: "fit-content"
//                                     }}>
//                                         <span style={{ fontSize: "14px" }}>📏</span>
//                                         <span style={{
//                                             fontSize: "13px",
//                                             color: "#1a73e8",
//                                             fontWeight: "500"
//                                         }}>
//                                             {dataval.length} characters
//                                         </span>
//                                     </div>
//                                 )}
//                             </div>
//                         </div>
//                     </div>
//                 </div>

//                 {/* Modal Footer */}
//                 <div style={{
//                     padding: "20px 32px",
//                     borderTop: "1px solid rgba(0, 0, 0, 0.05)",
//                     display: "flex",
//                     justifyContent: "flex-end",
//                     background: "white"
//                 }}>
//                     <button
//                         onClick={onClose}
//                         style={{
//                             background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
//                             color: "white",
//                             border: "none",
//                             padding: "12px 28px",
//                             borderRadius: "30px",
//                             fontSize: "14px",
//                             fontWeight: "600",
//                             cursor: "pointer",
//                             transition: "all 0.3s ease",
//                             boxShadow: "0 4px 14px rgba(102, 126, 234, 0.4)",
//                             display: "flex",
//                             alignItems: "center",
//                             gap: "8px"
//                         }}
//                         onMouseEnter={(e) => {
//                             e.target.style.background = "linear-gradient(135deg, #5a67d8 0%, #6b46a1 100%)";
//                             e.target.style.transform = "scale(1.02)";
//                             e.target.style.boxShadow = "0 6px 20px rgba(102, 126, 234, 0.5)";
//                         }}
//                         onMouseLeave={(e) => {
//                             e.target.style.background = "linear-gradient(135deg, #667eea 0%, #764ba2 100%)";
//                             e.target.style.transform = "scale(1)";
//                             e.target.style.boxShadow = "0 4px 14px rgba(102, 126, 234, 0.4)";
//                         }}
//                     >
//                         <span style={{ fontSize: "16px" }}>✓</span> Close
//                     </button>
//                 </div>
//             </div>
//         </div>
//     );
// };


// const WorkStatModal = ({ isOpen, onClose, data, usedFor }) => {
//     const [hovered, setHovered] = useState(false);
//     const [hoveredItem, setHoveredItem] = useState(null);

//     if (!isOpen || !data) return null;

//     // Helper function to get display value based on usedFor
//     const getDisplayData = () => {
//         if (usedFor === "workstat") {
//             return { type: "single", value: data.name, label: "WORK STAGE NAME", icon: "📋" };
//         }
//         else if (usedFor === "project_name") {
//             return { type: "single", value: data.project_name, label: "PROJECT NAME", icon: "📁" };
//         }
//         else if (usedFor === "list") {
//             return { type: "list", value: data, label: "LIST ITEMS", icon: "📋" };
//         }
//         else if (usedFor === "remarks") {
//             return { type: "list", value: data, label: "REMARKS", icon: "💬" };
//         }
//         else {
//             return { type: "single", value: data, label: "DETAILS", icon: "📄" };
//         }
//     };

//     const displayData = getDisplayData();

//     // Render single value
//     const renderSingleValue = () => (
//         <div
//             onMouseEnter={() => setHovered(true)}
//             onMouseLeave={() => setHovered(false)}
//             style={{
//                 background: hovered ? "#f8faff" : "white",
//                 borderRadius: "20px",
//                 padding: "28px",
//                 transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
//                 boxShadow: hovered
//                     ? "0 8px 20px rgba(79, 114, 202, 0.12), 0 2px 6px rgba(79, 114, 202, 0.05)"
//                     : "0 2px 8px rgba(0, 0, 0, 0.02)",
//                 transform: hovered ? "scale(1.01)" : "scale(1)",
//                 border: "1px solid rgba(255, 255, 255, 0.7)"
//             }}
//         >
//             <div style={{
//                 display: "flex",
//                 alignItems: "flex-start",
//                 gap: "20px"
//             }}>
//                 <div style={{
//                     width: "48px",
//                     height: "48px",
//                     background: hovered
//                         ? "linear-gradient(135deg, #667eea 0%, #764ba2 100%)"
//                         : "#f3f4f6",
//                     borderRadius: "16px",
//                     display: "flex",
//                     alignItems: "center",
//                     justifyContent: "center",
//                     color: hovered ? "white" : "#4b5563",
//                     fontSize: "20px",
//                     fontWeight: "600",
//                     transition: "all 0.3s ease"
//                 }}>
//                     {displayData.icon}
//                 </div>
//                 <div style={{ flex: 1 }}>
//                     <div style={{
//                         fontSize: "14px",
//                         fontWeight: "600",
//                         color: "#667eea",
//                         textTransform: "uppercase",
//                         letterSpacing: "0.5px",
//                         marginBottom: "8px"
//                     }}>
//                         {displayData.label}
//                     </div>
//                     <div style={{
//                         fontSize: "18px",
//                         color: hovered ? "#1e293b" : "#334155",
//                         fontWeight: hovered ? "600" : "500",
//                         lineHeight: "1.8",
//                         wordBreak: "break-word",
//                         whiteSpace: "pre-wrap",
//                         background: hovered ? "rgba(102, 126, 234, 0.02)" : "transparent",
//                         padding: "12px",
//                         borderRadius: "12px",
//                         transition: "all 0.2s ease"
//                     }}>
//                         {displayData.value || "-"}
//                     </div>
//                     {displayData.value && displayData.value.length > 200 && (
//                         <div style={{
//                             marginTop: "12px",
//                             display: "flex",
//                             alignItems: "center",
//                             gap: "8px",
//                             padding: "8px 12px",
//                             background: "#e8f0fe",
//                             borderRadius: "30px",
//                             width: "fit-content"
//                         }}>
//                             <span style={{ fontSize: "14px" }}>📏</span>
//                             <span style={{
//                                 fontSize: "13px",
//                                 color: "#1a73e8",
//                                 fontWeight: "500"
//                             }}>
//                                 {displayData.value.length} characters
//                             </span>
//                         </div>
//                     )}
//                 </div>
//             </div>
//         </div>
//     );

//     // Render list of values
//     const renderListValue = () => {
//         const listItems = Array.isArray(displayData.value) ? displayData.value : [];

//         return (
//             <div style={{
//                 background: "white",
//                 borderRadius: "20px",
//                 padding: "20px",
//                 border: "1px solid rgba(255, 255, 255, 0.7)"
//             }}>
//                 {/* List Header */}
//                 <div style={{
//                     display: "flex",
//                     alignItems: "center",
//                     gap: "12px",
//                     padding: "0 8px 16px 8px",
//                     borderBottom: "2px solid #f0f2f5",
//                     marginBottom: "16px"
//                 }}>
//                     <div style={{
//                         width: "36px",
//                         height: "36px",
//                         background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
//                         borderRadius: "10px",
//                         display: "flex",
//                         alignItems: "center",
//                         justifyContent: "center",
//                         color: "white"
//                     }}>
//                         {displayData.icon}
//                     </div>
//                     <div>
//                         <h3 style={{
//                             margin: 0,
//                             fontSize: "16px",
//                             fontWeight: "600",
//                             color: "#1e293b"
//                         }}>
//                             {displayData.label}
//                         </h3>
//                         <p style={{
//                             margin: "2px 0 0 0",
//                             fontSize: "13px",
//                             color: "#64748b"
//                         }}>
//                             {listItems.length} {listItems.length === 1 ? 'item' : 'items'} found
//                         </p>
//                     </div>
//                 </div>

//                 {/* List Items */}
//                 <div style={{
//                     maxHeight: "400px",
//                     overflowY: "auto",
//                     padding: "4px"
//                 }}>
//                     {listItems.length > 0 ? (
//                         listItems.map((item, index) => (
//                             <div
//                                 key={index}
//                                 onMouseEnter={() => setHoveredItem(index)}
//                                 onMouseLeave={() => setHoveredItem(null)}
//                                 style={{
//                                     background: hoveredItem === index ? "#f8faff" : "white",
//                                     borderRadius: "12px",
//                                     padding: "16px",
//                                     marginBottom: "8px",
//                                     transition: "all 0.2s ease",
//                                     boxShadow: hoveredItem === index
//                                         ? "0 4px 12px rgba(79, 114, 202, 0.08)"
//                                         : "0 2px 4px rgba(0, 0, 0, 0.02)",
//                                     border: "1px solid",
//                                     borderColor: hoveredItem === index ? "#667eea20" : "#edf2f7",
//                                     cursor: "pointer"
//                                 }}
//                             >
//                                 <div style={{
//                                     display: "flex",
//                                     alignItems: "flex-start",
//                                     gap: "12px"
//                                 }}>
//                                     <div style={{
//                                         width: "28px",
//                                         height: "28px",
//                                         background: hoveredItem === index
//                                             ? "linear-gradient(135deg, #667eea 0%, #764ba2 100%)"
//                                             : "#f1f5f9",
//                                         borderRadius: "8px",
//                                         display: "flex",
//                                         alignItems: "center",
//                                         justifyContent: "center",
//                                         color: hoveredItem === index ? "white" : "#475569",
//                                         fontSize: "13px",
//                                         fontWeight: "600",
//                                         transition: "all 0.2s ease"
//                                     }}>
//                                         {index + 1}
//                                     </div>
//                                     <div style={{ flex: 1 }}>
//                                         {typeof item === 'object' ? (
//                                             // If item is an object, display its properties
//                                             Object.entries(item).map(([key, value]) => (
//                                                 <div key={key} style={{
//                                                     display: "flex",
//                                                     marginBottom: "4px"
//                                                 }}>
//                                                     <span style={{
//                                                         fontSize: "12px",
//                                                         fontWeight: "600",
//                                                         color: "#667eea",
//                                                         minWidth: "100px",
//                                                         textTransform: "capitalize"
//                                                     }}>
//                                                         {key.replace(/_/g, ' ')}:
//                                                     </span>
//                                                     <span style={{
//                                                         fontSize: "14px",
//                                                         color: hoveredItem === index ? "#1e293b" : "#334155",
//                                                         fontWeight: hoveredItem === index ? "500" : "400",
//                                                         marginLeft: "8px"
//                                                     }}>
//                                                         {String(value) || '-'}
//                                                     </span>
//                                                 </div>
//                                             ))
//                                         ) : (
//                                             // If item is a string/number
//                                             <span style={{
//                                                 fontSize: "14px",
//                                                 color: hoveredItem === index ? "#1e293b" : "#334155",
//                                                 fontWeight: hoveredItem === index ? "500" : "400",
//                                                 lineHeight: "1.6",
//                                                 wordBreak: "break-word"
//                                             }}>
//                                                 {String(item)}
//                                             </span>
//                                         )}
//                                     </div>
//                                 </div>
//                             </div>
//                         ))
//                     ) : (
//                         <div style={{
//                             textAlign: "center",
//                             padding: "40px 20px"
//                         }}>
//                             <span style={{ fontSize: "48px", opacity: 0.5 }}>📭</span>
//                             <p style={{
//                                 color: "#94a3b8",
//                                 fontSize: "14px",
//                                 marginTop: "12px"
//                             }}>
//                                 No items to display
//                             </p>
//                         </div>
//                     )}
//                 </div>
//             </div>
//         );
//     };

//     return (
//         <div
//             style={{
//                 position: "fixed",
//                 top: 0,
//                 left: 0,
//                 right: 0,
//                 bottom: 0,
//                 height: "100vh",
//                 backgroundColor: "rgba(0, 0, 0, 0.5)",
//                 backdropFilter: "blur(8px)",
//                 display: "flex",
//                 alignItems: "center",
//                 justifyContent: "center",
//                 zIndex: 9999,
//                 animation: "fadeIn 0.3s ease"
//             }}
//             onClick={onClose}
//         >
//             <style>
//                 {`
//                     @keyframes fadeIn {
//                         from { opacity: 0; }
//                         to { opacity: 1; }
//                     }
//                     @keyframes slideUp {
//                         from { transform: translateY(30px); opacity: 0; }
//                         to { transform: translateY(0); opacity: 1; }
//                     }
//                 `}
//             </style>
//             <div
//                 style={{
//                     background: "white",
//                     borderRadius: "32px",
//                     maxWidth: displayData.type === "list" ? "800px" : "600px",
//                     width: "90%",
//                     position: "relative",
//                     boxShadow: "0 25px 50px -12px rgba(0, 0, 0, 0.25)",
//                     animation: "slideUp 0.4s cubic-bezier(0.16, 1, 0.3, 1)",
//                     border: "1px solid rgba(255, 255, 255, 0.5)",
//                     overflow: "hidden"
//                 }}
//                 onClick={(e) => e.stopPropagation()}
//             >
//                 {/* Modal Header - Same gradient for all */}
//                 <div style={{
//                     background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
//                     padding: "24px 32px",
//                     borderTopLeftRadius: "32px",
//                     borderTopRightRadius: "32px",
//                     display: "flex",
//                     alignItems: "center",
//                     justifyContent: "space-between"
//                 }}>
//                     <div style={{ display: "flex", alignItems: "center", gap: "16px" }}>
//                         <div style={{
//                             background: "rgba(255, 255, 255, 0.2)",
//                             width: "48px",
//                             height: "48px",
//                             borderRadius: "16px",
//                             display: "flex",
//                             alignItems: "center",
//                             justifyContent: "center",
//                             backdropFilter: "blur(4px)"
//                         }}>
//                             <span style={{ fontSize: "24px" }}>{displayData.icon}</span>
//                         </div>
//                         <div>
//                             <h2 style={{
//                                 margin: 0,
//                                 color: "white",
//                                 fontSize: "22px",
//                                 fontWeight: "700",
//                                 letterSpacing: "-0.5px"
//                             }}>
//                                 {displayData.label}
//                             </h2>
//                             <p style={{
//                                 margin: "4px 0 0 0",
//                                 color: "rgba(255, 255, 255, 0.9)",
//                                 fontSize: "14px"
//                             }}>
//                                 {displayData.type === "list" 
//                                     ? `${Array.isArray(displayData.value) ? displayData.value.length : 0} items available`
//                                     : "Complete details"
//                                 }
//                             </p>
//                         </div>
//                     </div>
//                     <button
//                         onClick={onClose}
//                         style={{
//                             background: "rgba(255, 255, 255, 0.2)",
//                             border: "none",
//                             width: "36px",
//                             height: "36px",
//                             borderRadius: "12px",
//                             display: "flex",
//                             alignItems: "center",
//                             justifyContent: "center",
//                             color: "white",
//                             fontSize: "24px",
//                             cursor: "pointer",
//                             backdropFilter: "blur(4px)",
//                             transition: "all 0.2s ease"
//                         }}
//                         onMouseEnter={(e) => {
//                             e.target.style.background = "rgba(255, 255, 255, 0.3)";
//                             e.target.style.transform = "scale(1.05)";
//                         }}
//                         onMouseLeave={(e) => {
//                             e.target.style.background = "rgba(255, 255, 255, 0.2)";
//                             e.target.style.transform = "scale(1)";
//                         }}
//                     >
//                         ×
//                     </button>
//                 </div>

//                 {/* Modal Content - Dynamic based on type */}
//                 <div 
//                     style={{
//                         padding: "32px",
//                         background: "linear-gradient(145deg, #ffffff 0%, #fafcff 100%)",
//                         maxHeight: "60vh",
//                         overflowY: "auto"
//                     }}
//                 >
//                     {displayData.type === "list" ? renderListValue() : renderSingleValue()}
//                 </div>

//                 {/* Modal Footer */}
//                 <div style={{
//                     padding: "20px 32px",
//                     borderTop: "1px solid rgba(0, 0, 0, 0.05)",
//                     display: "flex",
//                     justifyContent: "flex-end",
//                     background: "white"
//                 }}>
//                     <button
//                         onClick={onClose}
//                         style={{
//                             background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
//                             color: "white",
//                             border: "none",
//                             padding: "12px 28px",
//                             borderRadius: "30px",
//                             fontSize: "14px",
//                             fontWeight: "600",
//                             cursor: "pointer",
//                             transition: "all 0.3s ease",
//                             boxShadow: "0 4px 14px rgba(102, 126, 234, 0.4)",
//                             display: "flex",
//                             alignItems: "center",
//                             gap: "8px"
//                         }}
//                         onMouseEnter={(e) => {
//                             e.target.style.background = "linear-gradient(135deg, #5a67d8 0%, #6b46a1 100%)";
//                             e.target.style.transform = "scale(1.02)";
//                             e.target.style.boxShadow = "0 6px 20px rgba(102, 126, 234, 0.5)";
//                         }}
//                         onMouseLeave={(e) => {
//                             e.target.style.background = "linear-gradient(135deg, #667eea 0%, #764ba2 100%)";
//                             e.target.style.transform = "scale(1)";
//                             e.target.style.boxShadow = "0 4px 14px rgba(102, 126, 234, 0.4)";
//                         }}
//                     >
//                         <span style={{ fontSize: "16px" }}>✓</span> Close
//                     </button>
//                 </div>
//             </div>
//         </div>
//     );
// };

const WorkStatModal = ({ isOpen, onClose, data, usedFor }) => {
    const [hovered, setHovered] = useState(false);
    const [hoveredItem, setHoveredItem] = useState(null);

    if (!isOpen || !data) return null;

    // Helper function to get display value based on usedFor
    const getDisplayData = () => {
        if (usedFor === "workstat") {
            return { type: "single", value: data.name, label: "WORK STAGE NAME", icon: "📋" };
        }
        else if (usedFor === "project_name") {
            return { type: "single", value: data.project_name, label: "PROJECT NAME", icon: "📁" };
        }
        else if (usedFor === "workstages_list") {
            return { type: "list", value: data, label: "WORK STAGES", icon: "📋" };
        }
        else {
            return { type: "single", value: data, label: "DETAILS", icon: "📄" };
        }
    };

    const displayData = getDisplayData();

    // Render single value
    const renderSingleValue = () => (
        <div
            onMouseEnter={() => setHovered(true)}
            onMouseLeave={() => setHovered(false)}
            style={{
                background: hovered ? "#f8faff" : "white",
                borderRadius: "20px",
                padding: "28px",
                transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                boxShadow: hovered
                    ? "0 8px 20px rgba(79, 114, 202, 0.12), 0 2px 6px rgba(79, 114, 202, 0.05)"
                    : "0 2px 8px rgba(0, 0, 0, 0.02)",
                transform: hovered ? "scale(1.01)" : "scale(1)",
                border: "1px solid rgba(255, 255, 255, 0.7)"
            }}
        >
            <div style={{
                display: "flex",
                alignItems: "flex-start",
                gap: "20px"
            }}>
                <div style={{
                    width: "48px",
                    height: "48px",
                    background: hovered
                        ? "linear-gradient(135deg, #667eea 0%, #764ba2 100%)"
                        : "#f3f4f6",
                    borderRadius: "16px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: hovered ? "white" : "#4b5563",
                    fontSize: "20px",
                    fontWeight: "600",
                    transition: "all 0.3s ease"
                }}>
                    {displayData.icon}
                </div>
                <div style={{ flex: 1 }}>
                    <div style={{
                        fontSize: "14px",
                        fontWeight: "600",
                        color: "#667eea",
                        textTransform: "uppercase",
                        letterSpacing: "0.5px",
                        marginBottom: "8px"
                    }}>
                        {displayData.label}
                    </div>
                    <div style={{
                        fontSize: "18px",
                        color: hovered ? "#1e293b" : "#334155",
                        fontWeight: hovered ? "600" : "500",
                        lineHeight: "1.8",
                        wordBreak: "break-word",
                        whiteSpace: "pre-wrap",
                        background: hovered ? "rgba(102, 126, 234, 0.02)" : "transparent",
                        padding: "12px",
                        borderRadius: "12px",
                        transition: "all 0.2s ease"
                    }}>
                        {typeof displayData.value === 'string' ? displayData.value : JSON.stringify(displayData.value) || "-"}
                    </div>
                </div>
            </div>
        </div>
    );

    // Render list of workstages
    const renderWorkstagesList = () => {
        const listItems = Array.isArray(displayData.value) ? displayData.value : [];

        return (
            <div style={{
                background: "white",
                borderRadius: "20px",
                padding: "20px",
                border: "1px solid rgba(255, 255, 255, 0.7)"
            }}>
                {/* List Header */}
                <div style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "12px",
                    padding: "0 8px 16px 8px",
                    borderBottom: "2px solid #f0f2f5",
                    marginBottom: "16px"
                }}>
                    <div style={{
                        width: "36px",
                        height: "36px",
                        background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                        borderRadius: "10px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        color: "white"
                    }}>
                        {displayData.icon}
                    </div>
                    <div>
                        <h3 style={{
                            margin: 0,
                            fontSize: "16px",
                            fontWeight: "600",
                            color: "#1e293b"
                        }}>
                            {displayData.label}
                        </h3>
                        <p style={{
                            margin: "2px 0 0 0",
                            fontSize: "13px",
                            color: "#64748b"
                        }}>
                            {listItems.length} {listItems.length === 1 ? 'workstage' : 'workstages'} found
                        </p>
                    </div>
                </div>

                {/* List Items */}
                <div style={{
                    maxHeight: "400px",
                    overflowY: "auto",
                    padding: "4px"
                }}>
                    {listItems.length > 0 ? (
                        listItems.map((workstage, index) => (
                            <div
                                key={workstage.id || index}
                                onMouseEnter={() => setHoveredItem(index)}
                                onMouseLeave={() => setHoveredItem(null)}
                                style={{
                                    background: hoveredItem === index ? "#f8faff" : "white",
                                    borderRadius: "12px",
                                    padding: "16px",
                                    marginBottom: "8px",
                                    transition: "all 0.2s ease",
                                    boxShadow: hoveredItem === index
                                        ? "0 4px 12px rgba(79, 114, 202, 0.08)"
                                        : "0 2px 4px rgba(0, 0, 0, 0.02)",
                                    border: "1px solid",
                                    borderColor: hoveredItem === index ? "#667eea20" : "#edf2f7",
                                    cursor: "pointer"
                                }}
                            >
                                <div style={{
                                    display: "flex",
                                    alignItems: "flex-start",
                                    gap: "12px"
                                }}>
                                    <div style={{
                                        width: "28px",
                                        height: "28px",
                                        background: hoveredItem === index
                                            ? "linear-gradient(135deg, #667eea 0%, #764ba2 100%)"
                                            : "#f1f5f9",
                                        borderRadius: "8px",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        color: hoveredItem === index ? "white" : "#475569",
                                        fontSize: "13px",
                                        fontWeight: "600",
                                        transition: "all 0.2s ease"
                                    }}>
                                        {index + 1}
                                    </div>
                                    <div style={{ flex: 1 }}>
                                        {/* Render workstage name */}
                                        <div style={{
                                            fontSize: "16px",
                                            fontWeight: hoveredItem === index ? "600" : "500",
                                            color: hoveredItem === index ? "#1e293b" : "#334155",
                                            marginBottom: "4px"
                                        }}>
                                            {workstage.name || "Unnamed"}
                                        </div>




                                        {/* Render dates if available */}
                                        {(workstage.created_at || workstage.updated_at) && (
                                            <div style={{
                                                fontSize: "11px",
                                                color: "#94a3b8",
                                                marginTop: "8px",
                                                display: "flex",
                                                gap: "12px"
                                            }}>
                                                {workstage.created_at && (
                                                    <span>Created: {new Date(workstage.created_at).toLocaleDateString()}</span>
                                                )}
                                                {workstage.updated_at && (
                                                    <span>Updated: {new Date(workstage.updated_at).toLocaleDateString()}</span>
                                                )}
                                            </div>
                                        )}


                                    </div>
                                </div>
                            </div>
                        ))
                    ) : (
                        <div style={{
                            textAlign: "center",
                            padding: "40px 20px"
                        }}>
                            <span style={{ fontSize: "48px", opacity: 0.5 }}>📭</span>
                            <p style={{
                                color: "#94a3b8",
                                fontSize: "14px",
                                marginTop: "12px"
                            }}>
                                No workstages found
                            </p>
                        </div>
                    )}
                </div>
            </div>
        );
    };

    return (
        <div
            style={{
                position: "fixed",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                height: "100vh",
                backgroundColor: "rgba(0, 0, 0, 0.5)",
                backdropFilter: "blur(8px)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                zIndex: 9999,
                animation: "fadeIn 0.3s ease"
            }}
            onClick={onClose}
        >
            <style>
                {`
                    @keyframes fadeIn {
                        from { opacity: 0; }
                        to { opacity: 1; }
                    }
                    @keyframes slideUp {
                        from { transform: translateY(30px); opacity: 0; }
                        to { transform: translateY(0); opacity: 1; }
                    }
                `}
            </style>
            <div
                style={{
                    background: "white",
                    borderRadius: "32px",
                    maxWidth: usedFor === "workstages_list" ? "700px" : "600px",
                    width: "90%",
                    position: "relative",
                    boxShadow: "0 25px 50px -12px rgba(0, 0, 0, 0.25)",
                    animation: "slideUp 0.4s cubic-bezier(0.16, 1, 0.3, 1)",
                    border: "1px solid rgba(255, 255, 255, 0.5)",
                    overflow: "hidden"
                }}
                onClick={(e) => e.stopPropagation()}
            >
                {/* Modal Header */}
                <div style={{
                    background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                    padding: "24px 32px",
                    borderTopLeftRadius: "32px",
                    borderTopRightRadius: "32px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between"
                }}>
                    <div style={{ display: "flex", alignItems: "center", gap: "16px" }}>
                        <div style={{
                            background: "rgba(255, 255, 255, 0.2)",
                            width: "48px",
                            height: "48px",
                            borderRadius: "16px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            backdropFilter: "blur(4px)"
                        }}>
                            <span style={{ fontSize: "24px" }}>{displayData.icon}</span>
                        </div>
                        <div>
                            <h2 style={{
                                margin: 0,
                                color: "white",
                                fontSize: "22px",
                                fontWeight: "700",
                                letterSpacing: "-0.5px"
                            }}>
                                {displayData.label}
                            </h2>
                            <p style={{
                                margin: "4px 0 0 0",
                                color: "rgba(255, 255, 255, 0.9)",
                                fontSize: "14px"
                            }}>
                                {usedFor === "workstages_list"
                                    ? `${Array.isArray(displayData.value) ? displayData.value.length : 0} workstages available`
                                    : "Complete details"
                                }
                            </p>
                        </div>
                    </div>
                    <button
                        onClick={onClose}
                        style={{
                            background: "rgba(255, 255, 255, 0.2)",
                            border: "none",
                            width: "36px",
                            height: "36px",
                            borderRadius: "12px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            color: "white",
                            fontSize: "24px",
                            cursor: "pointer",
                            backdropFilter: "blur(4px)",
                            transition: "all 0.2s ease"
                        }}
                        onMouseEnter={(e) => {
                            e.target.style.background = "rgba(255, 255, 255, 0.3)";
                            e.target.style.transform = "scale(1.05)";
                        }}
                        onMouseLeave={(e) => {
                            e.target.style.background = "rgba(255, 255, 255, 0.2)";
                            e.target.style.transform = "scale(1)";
                        }}
                    >
                        ×
                    </button>
                </div>

                {/* Modal Content */}
                <div
                    style={{
                        padding: "32px",
                        background: "linear-gradient(145deg, #ffffff 0%, #fafcff 100%)",
                        maxHeight: "60vh",
                        overflowY: "auto"
                    }}
                >
                    {usedFor === "workstages_list" ? renderWorkstagesList() : renderSingleValue()}
                </div>

                {/* Modal Footer */}
                <div style={{
                    padding: "20px 32px",
                    borderTop: "1px solid rgba(0, 0, 0, 0.05)",
                    display: "flex",
                    justifyContent: "flex-end",
                    background: "white"
                }}>
                    <button
                        onClick={onClose}
                        style={{
                            background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                            color: "white",
                            border: "none",
                            padding: "12px 28px",
                            borderRadius: "30px",
                            fontSize: "14px",
                            fontWeight: "600",
                            cursor: "pointer",
                            transition: "all 0.3s ease",
                            boxShadow: "0 4px 14px rgba(102, 126, 234, 0.4)",
                            display: "flex",
                            alignItems: "center",
                            gap: "8px"
                        }}
                        onMouseEnter={(e) => {
                            e.target.style.background = "linear-gradient(135deg, #5a67d8 0%, #6b46a1 100%)";
                            e.target.style.transform = "scale(1.02)";
                            e.target.style.boxShadow = "0 6px 20px rgba(102, 126, 234, 0.5)";
                        }}
                        onMouseLeave={(e) => {
                            e.target.style.background = "linear-gradient(135deg, #667eea 0%, #764ba2 100%)";
                            e.target.style.transform = "scale(1)";
                            e.target.style.boxShadow = "0 4px 14px rgba(102, 126, 234, 0.4)";
                        }}
                    >
                        <span style={{ fontSize: "16px" }}>✓</span> Close
                    </button>
                </div>
            </div>
        </div>
    );
};

const handleErrorToast = (err, loadingToastId = null) => {
    if (loadingToastId) {
        toast.dismiss(loadingToastId);
    }

    if (err.response) {
        const errorData = err.response.data;

        // Case 1: Handle structured error with status + message
        if (errorData.status === 'error' && typeof errorData.message === 'string') {
            toast.error(`Error: ${errorData.message}`);
        }
        // Case 2: Generic message field
        else if (errorData.message) {
            toast.error(`Error: ${errorData.message}`);
        }
        // Case 3: Detailed token messages
        else if (errorData.detail && errorData.messages) {
            const detail = errorData.detail;
            const code = errorData.code;
            const messages = errorData.messages;

            toast.error(`Error: ${detail} (Code: ${code})`);

            messages.forEach(messageObj => {
                const tokenClass = messageObj.token_class || 'Unknown Token';
                const tokenType = messageObj.token_type || 'Unknown Type';
                const message = messageObj.message || 'Unknown Error';

                toast.error(`Token Class: ${tokenClass}, Type: ${tokenType} - ${message}`);
            });
        }
        // Case 4: Simple string error
        else if (typeof errorData.error === 'string') {
            toast.error(`Error: ${errorData.error}`);
        }
        // ✅ Case 5: Array of field errors (e.g. your tender_id case)
        else if (Array.isArray(errorData) && errorData.every(item => typeof item === 'object')) {
            errorData.forEach(errorObj => {
                Object.entries(errorObj).forEach(([field, messages]) => {
                    messages.forEach(message => toast.error(`"${field}": ${message}`));
                });
            });
        }
        // Case 6: Object of field errors
        else if (typeof errorData === 'object' && errorData !== null) {
            Object.entries(errorData).forEach(([field, messages]) => {
                if (Array.isArray(messages)) {
                    messages.forEach(message => toast.error(`"${field}": ${message}`));
                } else {
                    toast.error(`"${field}": ${messages}`);
                }
            });
        }
        // Case 7: HTML error page
        else if (typeof errorData === 'string' && errorData.includes("<html")) {
            const parser = new DOMParser();
            const doc = parser.parseFromString(errorData, "text/html");
            const pageTitle = doc.querySelector("title")?.innerText || 'Unknown Error';
            toast.error(`Error: ${pageTitle}`);
        }
        // Default fallback
        else {
            console.log("handleAllError fallback:");
            console.log(err);
            toast.error('Error: Failed to Process!');
        }
    } else {
        console.log("err : handleAllError (no response)");
        console.log(err);
        toast.error('Error processing your request.');
    }
};

const GetProgressColor = (percentage) => {
    // if (percentage < 10) return '#ff747c';
    if (percentage < 33) return '#ff747c';
    if (percentage < 66) return '#f7ba1e';
    return '#06ad06';
};

const ProgressModal = ({ show, progress, usedFor }) => (
    <Modal show={show} backdrop="static" keyboard={false} centered>
        <Modal.Header>
            <Modal.Title className="text-center uploading-percentage"
                style={{ width: "100%", color: usedFor === "Add" ? "green" : usedFor === "Update" ? "#f7941e" : usedFor === "Delete" ? "#f72b50" : "" }}>
                {usedFor === "Add" ? "Uploading" : usedFor === "Update" ? "Updating" : usedFor === "Delete" ? "Deleting" : ""} {progress}%</Modal.Title>
        </Modal.Header>
        <Modal.Body>

            <div
                className="progress-bar-fill"
                style={{ width: `${progress}%`, backgroundColor: usedFor === "Add" ? "green" : usedFor === "Update" ? "#f7941e" : usedFor === "Delete" ? "#f72b50" : "" }}></div>

        </Modal.Body>
    </Modal>
);
export {
    CSSForSelect,
    CSSForSelect15VW,
    CSSforMulti,
    CSSforMulti100Width,
    WorkStatModal,
    truncateText,
    handleErrorToast,
    GetProgressColor,
    ProgressModal,
    calculateTotal,
    formatCurrencyIndian
}